export const removeAllHtmlTagsAndTrim = (html: string): string => {
  return html.replace(/<[^>]+>/g, '').trim()
}

export const doBothTextsHaveSameCharacters = (text1: string, text2: string): boolean => {
  return removeAllHtmlTagsAndTrim(text1.replace(/\s/g, '')) === removeAllHtmlTagsAndTrim(text2.replace(/\s/g, ''))
}
